import type { PresenceViewer } from "../api/endpoints";
import { userDisplayName, userInitials } from "../lib/userAvatar";

interface PresenceAvatarsProps {
  viewers: PresenceViewer[];
  max?: number;
}

// Horizontal stack of peer avatars. Shows up to `max` circles followed by a
// +N pill; the full list is readable via the tooltip on the wrapper.
export function PresenceAvatars({ viewers, max = 3 }: PresenceAvatarsProps) {
  if (viewers.length === 0) return null;
  const visible = viewers.slice(0, max);
  const hidden = viewers.length - visible.length;
  const title = `Сейчас смотрят: ${viewers.map((v) => userDisplayName(v.name, v.email)).join(", ")}`;
  return (
    <div className="presence-avatars" title={title} aria-label={title}>
      {visible.map((v) => (
        <span key={v.id} className="presence-avatar" data-initials={userInitials(v.name, v.email)}>
          {v.picture ? (
            <img src={v.picture} alt={userDisplayName(v.name, v.email)} loading="lazy" />
          ) : (
            <span className="presence-avatar-initials">{userInitials(v.name, v.email)}</span>
          )}
        </span>
      ))}
      {hidden > 0 && <span className="presence-avatar presence-avatar--more">+{hidden}</span>}
    </div>
  );
}
